import VerifyPhone from './VerifyPhone';

export default VerifyPhone;
